import BasePage from "./base-page";

class Home extends BasePage {
  onReady() {
    requestAnimationFrame(() => {
      this.initFeaturedTabs();
      this.initMicroBanner();
    });
    this.defer(() => this.W__Descount());
    this.defer(() => this.W__Fqa());
  }
  defer(callback) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback);
    } else {
      setTimeout(callback, 200);
    }
  }

  initFeaturedTabs() {
    app.all(".tab-trigger", t => {
      t.addEventListener("click", ({ currentTarget }) => {
        const componentId = currentTarget.dataset.componentId;
        const targetId = currentTarget.dataset.target;

        app
          .toggleClassIf(`#${componentId} .tabs-wrapper>div`, "is-active opacity-0 translate-y-3", "inactive", a => a.id === targetId)
          .toggleClassIf(`#${componentId} .tab-trigger`, "is-active", "inactive", a => a === currentTarget);

        setTimeout(() => {
          app.toggleClassIf(`#${componentId} .tabs-wrapper>div`, "opacity-100 translate-y-0", "opacity-0 translate-y-3", a => a.id === targetId);
        }, 100);
      });
    });

    document.querySelectorAll(".s-block-tabs").forEach(t => t.classList.add("tabs-initialized"));
  }

  initMicroBanner() {
    app.all(".W__micr-banner", el => {
      const container = el.querySelector(".starshine");
      const template = container?.querySelector(".template.shine");
      if (!container || !template) return;

      const sizes = ["small", "medium", "large"];
      const frag = document.createDocumentFragment();

      for (let i = 0; i < 5; i++) {
        const star = template.cloneNode(true);
        app.removeClass(star, "hidden");
        app.addClass(star, sizes[i % sizes.length]);
        star.style.top = `${Math.random() * 100}%`;
        star.style.left = `${Math.random() * 100}%`;
        star.style.animationDelay = `${Math.random() * 5}s`;
        frag.appendChild(star);
      }

      container.appendChild(frag);
    });

    this.syncMicroBannerHeight();
  }

  /**
   * With obj_con (natural image size) the slides have no fixed height, so Swiper
   * measures them from the width/height attributes before the images decode and
   * the wrapper ends up too short — slides then bleed over each other. Re-measure
   * once each banner image is actually loaded.
   */
  syncMicroBannerHeight() {
    app.all(".W__micr salla-slider[auto-height='true']", slider => {
      const refresh = () => {
        slider.update?.();
        slider.updateAutoHeight?.(0);
      };

      const images = slider.querySelectorAll(".W__micr-banner img, .W__micr-banner video");
      if (!images.length) return;

      images.forEach(media => {
        if (media.tagName === "IMG" && media.complete) return;
        media.addEventListener("load", refresh, { once: true });
        media.addEventListener("loadeddata", refresh, { once: true });
        media.addEventListener("error", refresh, { once: true });
      });

      refresh();
    });
  }



  W__Descount() {
    if (!navigator.clipboard) return;

    app.all("[data-cop]", el => {
      const code = el.dataset.cop;
      if (!code || el.dataset.listenerAttached === "true") return;

      app.onClick(el, () => {
        navigator.clipboard.writeText(code)
          .then(() => salla.notify.success(`${salla.lang.get("pages.products.copied")} ${code} ✔`))
          .catch(() => salla.notify.error(`تعذر نسخ الكود ${code}`));
      });

      el.dataset.listenerAttached = "true";
    });
  }

  W__Fqa() {
    const questions = document.querySelectorAll(".W__faq_question");
    if (!questions.length) return;

    const closeOthers = current => {
      document.querySelectorAll(".W__faq_item").forEach(item => {
        if (item !== current) {
          item.classList.remove("open");
          item.querySelector(".W__faq_answer")?.classList.remove("open");
          item.querySelector(".W__faq_arrow")?.classList.remove("open");
          item.querySelector(".W__faq_question")?.setAttribute("aria-expanded", "false");
        }
      });
    };

    questions.forEach(q => {
      q.setAttribute("role", "button");
      q.setAttribute("tabindex", "0");
      q.setAttribute("aria-expanded", "false");

      const toggle = () => {
        const item = q.closest(".W__faq_item");
        const answer = q.nextElementSibling;
        const arrow = q.querySelector(".W__faq_arrow");
        const isOpen = item.classList.contains("open");

        item.classList.toggle("open", !isOpen);
        answer.classList.toggle("open", !isOpen);
        arrow.classList.toggle("open", !isOpen);
        q.setAttribute("aria-expanded", String(!isOpen));

        closeOthers(item);
      };

      q.addEventListener("click", toggle);
      q.addEventListener("keydown", e => {
        if (["Enter", " "].includes(e.key)) {
          e.preventDefault();
          toggle();
        }
      });
    });
  }
}

Home.initiateWhenReady(["index"]);
